export const neededColors = [
  "Black",
  "White",
  "Red",
  "Blue",
  "Green",
  "Yellow",
  "Orange",
  "Grey",
  "Silver",
  "Gold",
  "Bronze",
  "Brown",
  "Pink",
  "Purple",
  "Dark Grey",
  "Glow in the Dark",
  "Transparent",
  "Other"
];

/* Old hex values 
  "#3A353C",
  "#688356",
  "#C8AB13",
  "#2C3274",
  "#FBF519",
  "#A73225",
  "#DD5124",
  "#F9D4D4",
  "#FCFCFC",
  "#71F49E",
  "#F4A4249",
  "#C62F2C",
  "#201E24",
  "#C79B58",
  "#FBF3DA",
  "#F94A4C",
  "#7C778D",
  "#B9C3CC",
  "#DCFEO2",
  "#B8DE19",
  "#A48167",
  "#FBFCF4",
  "#7D513B",
  "#FDA33A",
  "#E8C9A3",
  "#9CA8BE",
  "#DAC784",
  "#A3ACB2",
  "#A0DAF6",
  "#F30BOB",
  "#FA8207",
  "#F8160A",
  "#FA98AB",
  "#B2D4E4",
  "#2C292B",
  "#0505E8",
  "#F80A09",
  "#FBFB05",
  "#2DEF8E",
  "#FBEF38",
  "#FA6E06",
  "#DBC69B",
  "#211C21",
  "#FCFCFC",
  "#B0784F",
  "#FBFB04",
  "#9606BC",
  "#F4F6F5",
  "#767E5E",
  "#F7F7F6",
  "#DOFB91",
  "#5E5261",
  "#0656B7",
  "#0CD46E",
  "#E2FB3C",
  "#FA93AB",
  "#F4F4F4",
  "#CFFB92",
  "#FAE2BD",
  */
